import { useMemo } from 'react';
import { matchPath, PathMatch } from 'react-router';

type FlightroomRouteParams = {
  channelId?: string;
  isChannelPath?: boolean;
  roomId?: string;
};

type FlightroomRouteMatch = (Omit<PathMatch<string>, 'params'> & { params: FlightroomRouteParams }) | null;

export const useMatchFlightroomRoute = (pathname: string): FlightroomRouteMatch => {
  return useMemo(() => {
    const channelMatch = matchPath({ path: '/dashboard/flightrooms/:roomId/channel/:channelId?' }, pathname);
    if (channelMatch) {
      return { ...channelMatch, params: { ...channelMatch.params, isChannelPath: true } };
    }
    return matchPath({ path: '/dashboard/flightrooms/:roomId?/:channelId?' }, pathname);
  }, [pathname]);
};
